<template>
    <div class="border-t border-gray-300 pt-4">
        <h3 class="col-span-2 text-base font-semibold">Ownership</h3>
        <div class="divide-y divide-gray-300">
            <div class="grid grid-cols-3 items-center py-2">
                <BaseInputCheckbox
                    v-model="formValues.share_of_ownership"
                    label="Control by share of ownership"
                    name="share_of_ownership"></BaseInputCheckbox>
                <div class="col-span-2">
                    <BaseInputText
                        v-model="formValues.share_of_ownership_company"
                        :disabled="!formValues.share_of_ownership"
                        name="share_of_ownership_company"
                        :label="$t('beneficial_owner.indirect_ownership')"></BaseInputText>
                    <div class="pt-2">
                        <BaseInputText
                            v-if="formValues.share_of_ownership"
                            v-model="formValues.company_share"
                            name="company_share"
                            label="If you are a Beneficial Owner by share of ownership, please indicate the share of ownership (%) " />
                    </div>
                </div>
            </div>
            <div class="grid grid-cols-3 items-center py-2">
                <BaseInputCheckbox
                    v-model="formValues.control_by_other_means"
                    label="Control by other means"
                    name="control_by_other_means"></BaseInputCheckbox>
                <div class="col-span-2">
                    <BaseInputText
                        v-model="formValues.control_by_other_means_company"
                        :disabled="!formValues.control_by_other_means"
                        name="control_by_other_means_company"
                        :label="$t('beneficial_owner.indirect_ownership')"></BaseInputText>
                </div>
            </div>
            <div class="grid grid-cols-3 items-center py-2">
                <BaseInputCheckbox
                    v-model="formValues.official_senior_manager"
                    label="Official senior manager"
                    name="official_senior_manager"></BaseInputCheckbox>
                <div class="col-span-2">
                    <BaseInputText
                        v-model="formValues.official_senior_manager_company"
                        :disabled="!formValues.official_senior_manager"
                        name="official_senior_manager_company"
                        :label="$t('beneficial_owner.indirect_ownership')"></BaseInputText>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseInputText from '../../../../base/BaseInputText.vue'
import BaseInputCheckbox from '../../../../base/BaseInputCheckbox.vue'
import { useVModel } from '@vueuse/core'
import { CompanyOwnership } from './forms'

const props = defineProps<{
    modelValue: CompanyOwnership
}>()
const emit = defineEmits(['update:modelValue'])

const formValues = useVModel(props, 'modelValue', emit)
</script>

<style scoped></style>
